import { combineReducers } from 'redux';

import requestReducer from '@store/requests';
import settingsReducer from '@store/settings';
import submitReducer from '@store/submit';

export default combineReducers({
    settings: settingsReducer,
    submit: submitReducer,
    request: requestReducer
});
